module.exports = __webpack_public_path__ + "static/media/YM56_0.5ed61a7f.jpg";